"use client";

import DeviceProvider from "../../redux/features/device/DeviceProvider";
import ChristmasRaffleContentPage from "./page-content";
import RaffleContextProvider from "./provider";
import { publishModalVisibility } from "../../redux/features/modal/modalSlice";
import Modal from "../../components/Modal/modal";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";

const ChristmasRafflePage = () => {
  const dispatch = useAppDispatch();
  const buyYourTicketsModalData = useAppSelector(state => state.modal.data);
  const isBuyTicketModalVisible = useAppSelector(state => state.modal.isOpen);
  const withOverlay = useAppSelector(state => state.modal.withOverlay);
  return (
    <DeviceProvider>
      <RaffleContextProvider>
        <ChristmasRaffleContentPage />
        <Modal
          isOpen={isBuyTicketModalVisible}
          title=""
          withOverlay={withOverlay}
          closeModal={event => {
            event.stopPropagation();
            dispatch(publishModalVisibility({ isOpen: false }));
          }}
          modalClassNames={`md:rounded-2xl xs:absolute xs:bottom-0 xs:w-full xs:rounded-b-none xs:rounded-t-2xl z-10 !max-h-none ${isBuyTicketModalVisible ? "!px-4 pt-12 pb-8 max-lg:!pb-4 lg:!px-8 lg:!pb-10 lg:!pt-12" : ""}`}
          body={buyYourTicketsModalData}
        />
      </RaffleContextProvider>
    </DeviceProvider>
  );
};

export default ChristmasRafflePage;
